import * as React from 'react';
import type { SVGProps } from 'react';
const BriefCaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4177 6.3439C21.4165 6.3439 21.4153 6.34375 21.4141 6.34375H16.1016V5.75781C16.1016 4.78857 15.313 4 14.3438 4H9.65625C8.68701 4 7.89844 4.78857 7.89844 5.75781V6.34375H2.58594C2.2597 6.34375 2 6.61108 2 6.92969V19.8203C2 20.7896 2.78857 21.5781 3.75781 21.5781H20.2422C21.2114 21.5781 22 20.7896 22 19.8203V6.94205C22 6.94128 22 6.94052 22 6.93976C21.9776 6.55493 21.7409 6.34604 21.4177 6.3439ZM9.07031 5.75781C9.07031 5.43478 9.33322 5.17188 9.65625 5.17188H14.3438C14.6668 5.17188 14.9297 5.43478 14.9297 5.75781V6.34375H9.07031V5.75781ZM20.6011 7.51562L18.7815 12.9743C18.7017 13.214 18.4783 13.375 18.2257 13.375H14.9297V12.7891C14.9297 12.4654 14.6674 12.2031 14.3438 12.2031H9.65625C9.33261 12.2031 9.07031 12.4654 9.07031 12.7891V13.375H5.77426C5.52173 13.375 5.29834 13.214 5.21854 12.9743L3.39893 7.51562H20.6011ZM13.7578 13.375V14.5469H10.2422V13.375H13.7578ZM20.8281 19.8203C20.8281 20.1433 20.5652 20.4062 20.2422 20.4062H3.75781C3.43478 20.4062 3.17188 20.1433 3.17188 19.8203V10.5404L4.10678 13.3449C4.34634 14.0639 5.01651 14.5469 5.77426 14.5469H9.07031V15.1328C9.07031 15.4565 9.33261 15.7188 9.65625 15.7188H14.3438C14.6674 15.7188 14.9297 15.4565 14.9297 15.1328V14.5469H18.2257C18.9835 14.5469 19.6537 14.0639 19.8932 13.3449L20.8281 10.5404V19.8203Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.6"
    />
  </svg>
);
export default BriefCaseIcon;
